// extracted by mini-css-extract-plugin
module.exports = {"switx-app-message":"AppMessage_switx-app-message__1yZq4"};